module.exports = __webpack_public_path__ + "img/galatasaray.a53c6e94.png";